import { createTheme } from "@mui/material/styles";

const ccTheme = createTheme({
  typography: {
    // fontFamily: ['Montserrat', "Roboto", "Helvetica", "Arial", "sans-serif"].join(','),
    // fontSize: 16,
    // fontWeightRegular: 500
    h1: {
      fontSize: 80,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    h2: {
      fontSize: 70,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    h3: {
      fontSize: 40,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    h4: {
      fontSize: 40,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    h5: {
      fontSize: 30,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    h6: {
      fontSize: 24,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    swipe: {
      fontSize: 25,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    button: {
      fontSize: 30,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
      textTransform: "none",
    },
    buttonE3: {
      fontSize: 22,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
      textTransform: "none",
    },
    body1: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    body1Outfit: {
      fontSize: 20,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    body2: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    body3: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    body4: {
      fontSize: 22,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    body5: {
      fontSize: 18,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    caption: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    caption2: {
      fontSize: 22,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    caption3: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    caption4: {
      fontSize: 18,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    card: {
      fontSize: 18,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    cardOutfit: {
      fontSize: 18,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    popupTitle: {
      fontSize: 24,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    popupTitleOutfit: {
      fontSize: 24,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    cardLight: {
      fontSize: 22,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    cardBold: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    cardLarge: {
      fontSize: 40,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    caption3Light: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    caption3LightOutfit: {
      fontSize: 16,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    caption4Light: {
      fontSize: 14,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
    },
    caption4LightOutfit: {
      fontSize: 14,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    caption4Outfit: {
      fontSize: 14,
      fontFamily: "Outfit",
      fontWeight: 500,
    },
    caption3Bold: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    ingredientText1: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 500,
    },
    ingredientText1Outfit: {
      fontSize: 16,
      fontFamily: "Outfit",
      fontWeight: 500,
    },
    ingredientText2: {
      fontSize: 18,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    ingredientText1paralell: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 500,
    },
    ingredientText2paralell: {
      fontSize: 12,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    ingredientText2paralellOutfit: {
      fontSize: 12,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    caloriesText: {
      fontSize: 12,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    caption2paralell: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    captionparalell: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    body2paralell: {
      fontSize: 14,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    ingredientText1mini: {
      fontSize: 15,
      fontFamily: "Nunito Sans",
      fontWeight: 500,
    },
    ingredientText2mini: {
      fontSize: 14,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    caption2mini: {
      fontSize: 16,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    captionmini: {
      fontSize: 17,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    body2mini: {
      fontSize: 18,
      fontFamily: "Nunito Sans",
      fontWeight: 300,
    },
    preSlideHeading: {
      fontSize: 30,
      fontFamily: "Nunito Sans",
      fontWeight: 700,
    },
    timeTextSettings: {
      fontSize: 24,
      fontFamily: "Nunito Sans",
      fontWeight: 600,
    },
    referralPopupText: {
      fontSize: 24,
      fontFamily: "Outfit",
      fontWeight: 500,
    },
    tagsAndTimeAndServingSize: {
      fontSize: 12,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    recipeName: {
      fontSize: 16,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    ratingText: {
      fontSize: 12,
      fontFamily: "Outfit",
      fontWeight: 600,
    },
    planWithUpText: {
      fontSize: 12,
      fontFamily: "Outfit",
      fontWeight: 500,
    },
    headerOutfit: {
      fontSize: 24,
      fontFamily: "Outfit",
      fontWeight: 400,
    },
    ingredientText2miniOutfit: {
      fontSize: 16,
      fontFamily: "Outfit",
      fontWeight: 600,
    },
    miniPlayerText: {
      fontSize: 16,
      fontWeight: 700,
      fontFamily: "Nunito Sans",
    },
    preSlideBody: {
      fontSize: 20,
      fontFamily: "Nunito Sans",
      fontWeight: 400,
      caption3Light: {
        fontSize: 16,
        fontFamily: "Nunito Sans",
        fontWeight: 400,
      },
      caption3Bold: {
        fontSize: 16,
        fontFamily: "Nunito Sans",
        fontWeight: 700,
      },

    },
  },
  palette: {
    primary: {
      main: "#FD8D3D",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#043F98",
    },
  },
});

export default ccTheme;
